//import supabase from './supabaseClient';
import React, {  } from "react"; // useState

// var pageName = 'Profile'; // Default page name
// var selectedCategory = 'null'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'pageName') {
      // pageName = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}


function Admin() { 

  // const [users, setUsers] = useState([]);
  // const [questions, setQuestions] = useState([]);
  // const [categories, setCategories] = useState([]);
  // const [vouchers, setVouchers] = useState([]);
  // const [appConfig, setAppConfig] = useState([]);
  // const [loading, setLoading] = useState({
  //   users: false,
  //   questions: false,
  //   categories: false,
  //   vouchers: false,
  //   appConfig: false,
  // });

  // const loadUsers = async () => {
  //   setLoading(l => ({ ...l, users: true }));
  //   const { data, error } = await supabase.from('Users').select('userid, emailid, username, active');
  //   if (!error) setUsers(data || []);
  //   setLoading(l => ({ ...l, users: false }));
  // };

  // const loadCategories = async () => {
  //   setLoading(l => ({ ...l, categories: true }));
  //   const { data, error } = await supabase
  //     .from('Category')
  //     .select('id, CategoryName, Questions(count)')
  //     .order('id', { ascending: true });
  //   if (!error) setCategories(data || []);
  //   setLoading(l => ({ ...l, categories: false }));
  // };


  // const sectionStyle = {
  //   border: '1px solid #ccc',
  //   borderRadius: '8px',
  //   margin: '16px 0',
  //   padding: '12px',
  //   background: '#fafafa',
  // };
  // const listStyle = {
  //   maxHeight: '200px',
  //   overflowY: 'auto',
  //   background: '#fff',
  //   padding: '8px',
  //   borderRadius: '4px',
  //   border: '1px solid #eee',
  // };

  return (
    <div style={{ padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '1.1em' }}>
      <h3 style={{ color: 'blue', textAlign: 'center' }}>Admin Page</h3>
      <p>Welcome to the Admin Page.</p>

      {/* Users Section */}
      {/* <div style={sectionStyle}>
        <h4>Users</h4>
        <button onClick={loadUsers} disabled={loading.users}>
          {loading.users ? 'Loading...' : 'Load Users'}
        </button>
        <div style={listStyle}>
          {users.length === 0 ? (
            <span>No data</span>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.95em' }}>
              <thead>
                <tr>
                  {Object.keys(users[0]).map(col => (
                    <th key={col} style={{ borderBottom: '1px solid #ddd', padding: '4px', textAlign: 'left' }}>{col}</th>
                  ))}
                  <th style={{ borderBottom: '1px solid #ddd', padding: '4px', textAlign: 'left' }}>Active</th>
                  <th style={{ borderBottom: '1px solid #ddd', padding: '4px', textAlign: 'left' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    {Object.keys(u).map(col => (
                      <td key={col} style={{ borderBottom: '1px solid #eee', padding: '4px' }}>{String(u[col])}</td>
                    ))}
                    <td style={{ borderBottom: '1px solid #eee', padding: '4px' }}>
                      {u.active ? 'Active' : 'Inactive'}
                    </td>
                    <td style={{ borderBottom: '1px solid #eee', padding: '4px' }}>
                      <button
                        disabled={u.active}
                        style={{ marginRight: '6px', padding: '2px 8px', background: u.active ? '#eee' : 'blue', color: '#fff', border: 'none', borderRadius: '4px', cursor: u.active ? 'not-allowed' : 'pointer' }}
                        onClick={async () => {
                          const { error } = await supabase
                            .from('Users')
                            .update({ active: true })
                            .eq('userid', u.userid);
                          if (error) {
                            alert(`Error activating user: ${error.message}`);
                          } else {
                            alert('User activated successfully.');
                          }
                          loadUsers();
                        }}
                      >
                        Activate
                      </button>
                      <button
                        disabled={!u.active}
                        style={{ padding: '2px 8px', background: !u.active ? '#eee' : '#ff595e', color: '#fff', border: 'none', borderRadius: '4px', cursor: !u.active ? 'not-allowed' : 'pointer' }}
                        onClick={async () => {
                          const { error } = await supabase
                            .from('Users')
                            .update({ active: false })
                            .eq('userid', u.userid);
                          if (error) {
                            alert(`Error deactivating user: ${error.message}`);
                          } else {
                            alert('User deactivated successfully.');
                          }
                          loadUsers();
                        }}
                      >
                        Deactivate
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div> */}

      {/* Categories Section */}
      {/* <div style={sectionStyle}>
        <h4>Categories</h4>
        <button onClick={loadCategories} disabled={loading.categories}>
          {loading.categories ? 'Loading...' : 'Load Categories'}
        </button>
        <div style={listStyle}>
          {categories.length === 0 ? (
            <span>No data</span>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.95em' }}>
              <thead>
                <tr>
                  {Object.keys(categories[0]).map(col => (
                    <th key={col} style={{ borderBottom: '1px solid #ddd', padding: '4px', textAlign: 'left' }}>{col}</th>
                  ))}
                  <th style={{ borderBottom: '1px solid #ddd', padding: '4px', textAlign: 'left' }}>Question Count</th>
                </tr>
              </thead>
              <tbody>
                {categories.map(c => {
                  const catId = c.id || c.categoryid || c.categoryId;
                  const count = questions.filter(q =>
                    q.categoryid === catId ||
                    q.categoryId === catId ||
                    q.category === c.name ||
                    q.category === c.category
                  ).length;
                    // Show the question count for this category from the joined query (if available)
                    const joinedCount = Array.isArray(c.Questions) && c.Questions[0]?.count !== undefined
                    ? c.Questions[0].count
                    : count;
                    return (
                    <tr key={catId}>
                      {Object.keys(c).map(col => (
                      <td key={col} style={{ borderBottom: '1px solid #eee', padding: '4px' }}>{String(c[col])}</td>
                      ))}
                      <td style={{ borderBottom: '1px solid #eee', padding: '4px' }}>{joinedCount}</td>
                    </tr>
                    );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div> */}

    </div>
  );
}

export default Admin;